// extracted by mini-css-extract-plugin
module.exports = {"container":"_34Mk2","title":"_2F3d1"};